var canvas, canvas2, text, newText, zoom, cWidth = 1000, cHeight = 1429,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, placeholderimg2, currentSignature,
    placeholderimg4,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB0W = 175, sizeB0H = 131,
    sizeB1W = 170, sizeB1H = 70;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


let backImg = document.querySelector("#background_birthday");
let bg_img = new fabric.Image(backImg, {
  left: 0,   
  top: 0,
  scaleX: 1.4,
  scaleY: 1.4,
  selectable: false
});


window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

window['canvas2'].add(bg_img);
bg_img.sendToBack();
addModify(window['canvas2']);



let currentImgInstance = null; 


document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const defaultImgUrl = document.getElementById('image_preview')?.src;
    const canvas = window['canvas2'];
    const placeholder = window['placeholderimg0'];

    if (defaultImgUrl && canvas && placeholder) {
      fabric.Image.fromURL(defaultImgUrl, function (imgInstance) {
        imgInstance.set({
          left: placeholder.left,
          top: placeholder.top,
          scaleX: placeholder.width / imgInstance.width,
          scaleY: placeholder.height / imgInstance.height,
          selectable: false
        });

        imgInstance.bringToFront();
        canvas.add(imgInstance);
        canvas.renderAll();

        currentImgInstance = imgInstance;
      });
    }
  }, 300); // Wait for canvas and elements to be ready
});


window['placeholderimg0'] = new fabric.Rect({
  left: 500,
  top: 590,
  width: sizeB0W,
  height: sizeB0H,
  fill: 'rgba(0,0,0,0)'
});



window['canvas2'].add(window['placeholderimg0']);


document.getElementById('image_upload_logo').addEventListener('change', function(e) {
  canvas = window['canvas2'];
  available_height = sizeB0H;
  img = window['placeholderimg0'];
  sizeCrop = '1.34';

  if (currentImgInstance) {
    canvas.remove(currentImgInstance);
    currentImgInstance = null;
  }
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height', available_height);
  readURL2(e.target, '#image0');
});




var maxWidth = 185;
var maxHeight = 50;

var para = "Star of\nExcellence Award" ;

window['text1Page'] = new fabric.Text(para,{
  left: 495,
  top: 715,
  width: 185,
  fontSize: 22,
  lineHeight: 1,
  fontFamily: 'Times New Roman',
  textAlign: 'center',
  isWrapping: true,
  fill: '#fff'
});


window['canvas2'].add(window['text1Page']);


var minFontSize = 10;
var maxFontSize = 23;

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Star of\nExcellence Award') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_1').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text1Page'].set({
    text: input
  });
  fitTextToBox(window['text1Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}



window['text2Page'] = new fabric.Text('Presented to',{
  left: 500,
  top: 790,
  fontSize: 23,
  fontFamily: 'Times New Roman',
  fill: '#fff',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

window['canvas2'].add(window['text2Page']);



var maxWidth3 = 160;
var maxHeight3 = 70;

var para = "Gulfam\nAhmad" ;

window['text3Page'] = new fabric.Text(para,{
  left: 500,
  top: 875,
  width: 160,
  fontSize: 32,
  lineHeight: 1.2,
  fontFamily: 'Galada',
  textAlign: 'center',
  isWrapping: true,
  fill: '#fff'
});


var fontName = window['text3Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');


window['canvas2'].add(window['text3Page']);


var minFontSize3 = 10;
var maxFontSize3 = 32;

// Clear text on input focus if default
document.getElementById('text_3').addEventListener('focus', function () {
  if (window['text3Page'].text === 'Gulfam\nAhmad') {
    window['text3Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText3(textbox, maxW, maxH) {
  let fontSize = maxFontSize3;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize3
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_3').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text3Page'].set({
    text: input
  });
  fitTextToBox3(window['text3Page'], maxWidth3, maxHeight3);
});

function fitTextToBox3(textObj, maxWidth3, maxHeight3) {
  let fontSize = maxFontSize3;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth3 || textObj.height > maxHeight3;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize3) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




var maxWidth4 = 110;
var maxHeight4 = 100;

var para = "Year\n2025" ;

window['text4Page'] = new fabric.Text(para,{
  left: 500,
  top: 995,
  width: 110,
  fontSize: 26,
  lineHeight: 1.3,
  fontFamily: 'Times New Roman',
  textAlign: 'center',
  isWrapping: true,
  fill: '#fff'
});


window['canvas2'].add(window['text4Page']);


var minFontSize4 = 10;
var maxFontSize4 = 26;

// Clear text on input focus if default
document.getElementById('text_4').addEventListener('focus', function () {
  if (window['text4Page'].text === 'Year\n2025') {
    window['text4Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText4(textbox, maxW, maxH) {
  let fontSize = maxFontSize4;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize4
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_4').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text4Page'].set({
    text: input
  });
  fitTextToBox4(window['text4Page'], maxWidth4, maxHeight4);
});

function fitTextToBox4(textObj, maxWidth4, maxHeight4) {
  let fontSize = maxFontSize4;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth4 || textObj.height > maxHeight4;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize4) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




var maxWidth5 = 280;
var maxHeight5 = 200;

var para = "Presented as a token of\nappreciation for exceptional\nleadership and inspiring journey.\nYour ability to guide, empower,\nand motivate others has created\na legacy of success." ;

window['text5Page'] = new fabric.Text(para,{
  left: 495,
  top: 1282,
  width: 280,
  fontSize: 21,
  lineHeight: 1.2,
  fontFamily: 'Times New Roman',
  textAlign: 'center',
  isWrapping: true,
  fill: '#fff'
});


window['canvas2'].add(window['text5Page']);


var minFontSize5 = 10;
var maxFontSize5 = 22;

// Clear text on input focus if default
document.getElementById('text_5').addEventListener('focus', function () {
  if (window['text5Page'].text === 'Presented as a token of\nappreciation for exceptional\nleadership and inspiring journey.\nYour ability to guide, empower,\nand motivate others has created\na legacy of success.') {
    window['text5Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText5(textbox, maxW, maxH) {
  let fontSize = maxFontSize5;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize5
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_5').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text5Page'].set({
    text: input
  });
  fitTextToBox5(window['text5Page'], maxWidth5, maxHeight5);
});

function fitTextToBox5(textObj, maxWidth5, maxHeight5) {
  let fontSize = maxFontSize5;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth5 || textObj.height > maxHeight5;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler() {
  var activeOb = window['canvas2'].getActiveObject();
  if (activeOb) {
    window['canvas2'].remove(activeOb);
    window['canvas2'].renderAll();
  }
}


initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(window['placeholderimg0']).renderAll();
  fabric.Image.fromURL(imgurl, function(newImg){
    newImg.set({
      left: img.left,
      top: img.top,
      selectable: img.selectable
    });
    newImg.scaleToHeight(available_height);
    canvas.add(newImg).renderAll();
    window['placeholderimg0'] = newImg;
    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  jQuery(this).attr('data-cropped',imgurl);
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});


jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  fontFamily = jQuery(this).val();
  canvas.renderAll();
  fitTextToBox3(window['text3Page'], maxWidth3, maxHeight3);
});



jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});



// jQuery(window).on('load',function(){
//   canvasBlock(canvas2);
//   window['text2Page'].set('text','YEARS OF SERVICE AWARD');
//   window['text4Page'].set('text','Imran Yaqoob');
//   window['canvas2'].renderAll();
//   // loadFirstImg();
// });


// function getCookie(name){
//   let nameEQ = name + "=";
//   let cookies = document.cookie.split(";");
//   for (let i = 0; i < cookies.length; i++){
//     let cookie = cookies[i].trim();
//     if(cookie.indexOf(nameEQ) === 0){
//       return cookie.substring(nameEQ.length, cookie.length);
//     }
//   }
//   return null;
// }

// window.addEventListener("load", function(){
//   if(getCookie("firstVisit")){
//     console.log("✅ Cookie exists:", getCookie("firstVisit"));
//   } else{
//     console.log("❌ Cookie does not exist!");
//     document.cookie = "firstVisit=lamaPao; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
//     location.reload();
//   }
// });



async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    const croppedURL = jQuery(input).attr('data-cropped');
    if(croppedURL != ''){
      temp_images.push(croppedURL);
    }
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1, wall = 1, upCrop;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        if (int % 2 === 0) {
          upCrop = 'User Uploaded ';
        }else{
          upCrop = 'Cropped ';
        }
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties['+ upCrop + wall+']">');
        if(upCrop == 'User Uploaded '){
          wall += 1;
        }
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
var size,thumbnail;
var loadedObject,enterTitle,enterName,chooseFont,enterYear,enterQuote,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    canvas.remove(bg_img);
    window['canvas2'] = canvas.toDataURL('image/png');
    enterTitle = jQuery('.enter_title textarea').val();
    enterName = jQuery('.enter_name textarea').val();
    chooseFont = jQuery('.choose_font option:selected').val();
    enterYear = jQuery('.enter_year textarea').val();
    enterQuote = jQuery('.enter_quote textarea').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#enterTitle').val(enterTitle);
      jQuery('#enterName').val(enterName);
      jQuery('#chooseFont').val(chooseFont);
      jQuery('#enterYear').val(enterYear);
      jQuery('#enterQuote').val(enterQuote);
      jQuery('#addInfo').val(additionalInfo);
      //console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});



function resizeObjects(canvas) {
  let objectsToGroup = [];

  // ✅ Add text fields if exist
  for (let i = 1; i <= 5; i++) {
    if (window[`text${i}Page`]) {
      window[`text${i}Page`].setCoords();
      objectsToGroup.push(window[`text${i}Page`]);
    }
  }

  if (typeof currentImgInstance !== 'undefined' && currentImgInstance) {
    currentImgInstance.setCoords();
    objectsToGroup.push(currentImgInstance);
  }
  if (typeof img !== 'undefined' && img) {
    img.setCoords();
    objectsToGroup.push(img);
  }
  if (typeof window['placeholderimg0'] !== 'undefined' && window['placeholderimg0']) {
    window['placeholderimg0'].setCoords();
    objectsToGroup.push(window['placeholderimg0']);
  }


  
  if (objectsToGroup.length === 0) return;


  var designResiz = new fabric.Group(objectsToGroup, {
    left: halfWidth,
    top: halfHeight,
    originX: 'center',
    originY: 'center'
  });


  designResiz.scaleToHeight('1300');
  designResiz.setCoords();

  canvas.renderAll();
}


function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(bg_img);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}